import { render } from "./CloverTerminalsModal.vue?vue&type=template&id=15c3ecbf"
import script from "./CloverTerminalsModal.vue?vue&type=script&lang=js"
export * from "./CloverTerminalsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__